import classNames from 'classnames';
import React, { FC, useMemo } from 'react';

import { Image } from '../../Image';
import { useScreenSize } from '../../ScreenSize';

import styles from './TitleColCard.module.scss';

interface ContentTypes {
  imgUrl: string;
  moImgUrl?: string;
  title: string;
  description: string;
  direction: 'row' | 'column';
}

interface Props {
  title: string;
  contents: Array<ContentTypes | ContentTypes[]>;
}

const ImageCardItem: FC<ContentTypes> = (props) => {
  const { imgUrl, title, description, moImgUrl, direction = 'row' } = props;

  const { size } = useScreenSize(); // 页面尺寸属性

  const img = useMemo(() => {
    if (size.width < 1024) {
      return moImgUrl || imgUrl;
    }
    return imgUrl;
  }, [size]);

  const className = classNames(styles['image-card-container'], styles[`image-card-${direction}-direction-container`]);
  return (
    <div className={className}>
      <div className={styles['image-card-image-item']}>
        <Image objectFit="cover" src={img} layout="fill" compressOptions={{ quality: 70 }} />
      </div>
      <div className={styles['image-card-content']}>
        {title && <div className={styles['image-card-content-title']}>{title}</div>}
        {description && <div className={styles['image-card-content-desc']}>{description}</div>}
      </div>
    </div>
  );
};

const ImageCardColumnItems: FC<{ items: ContentTypes[] }> = (props) => {
  const { items } = props;
  return (
    <div className={styles['img-card-columns-container']}>
      {items.map((item, _idx) => (
        <div className={styles['image-card-column-container']} key={_idx}>
          <div className={styles['image-card-image-item']}>
            <Image objectFit="cover" src={item.imgUrl} layout="fill" compressOptions={{ quality: 70 }} />
          </div>
          <div className={styles['image-card-content']}>
            {item.title && <div className={styles['image-card-content-title']}>{item.title}</div>}
            {item.description && <div className={styles['image-card-content-desc']}>{item.description}</div>}
          </div>
        </div>
      ))}
    </div>
  );
};

const TitleCard: FC<Props> = (props) => {
  const { title, contents } = props;

  const contentsNode = Array.isArray(contents) && contents.length && (
    <div className={styles['title-card-content-wrap']}>
      {contents.map((contentItem, idx) =>
        Array.isArray(contentItem) ? (
          <ImageCardColumnItems items={contentItem} key={idx} />
        ) : (
          <ImageCardItem {...contentItem} key={idx} />
        ),
      )}
    </div>
  );

  return (
    <div className={styles['title-col-card-wrap']}>
      <div className={styles['title-card-container']}>
        {title && <div className={styles['title-card-title-content']}>{title}</div>}
        {contentsNode}
      </div>
    </div>
  );
};

TitleCard.displayName = 'TitleCard';
TitleCard.defaultProps = {
  title: '',
  contents: [],
};

export default TitleCard;
